module.exports = __webpack_public_path__ + "static/media/edit.5a6ab714.svg";